export default "__VITE_ASSET__5d3d0332__"